import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './AdminUserManager.css';

const AdminUserManager = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.get('/admin/users');
      setUsers(response.data.items || []);
    } catch (err) {
      setError(err.response?.data?.message || 'Хэрэглэгч авах үед алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (user) => {
    setSelectedUser(user);
  };

  // Хэрэглэгч устгах
  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Энэ хэрэглэгчийг устгах уу?')) return;
    try {
      await api.delete(`/admin/users/${userId}`);
      setUsers(users.filter(u => u._id !== userId));
      setSelectedUser(null);
    } catch (err) {
      alert(err.response?.data?.message || 'Устгах үед алдаа гарлаа');
    }
  };

  return (
    <div className="admin-user-manager">
      <div className="user-manager-header">
        <h2>Хэрэглэгч удирдлага</h2>
        <div className="user-stats">
          <div className="stat-box">
            <span className="stat-label">Нийт хэрэглэгч</span>
            <span className="stat-value">{users.length}</span>
          </div>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <p>Хэрэглэгч авч байна...</p>
      ) : (
        <div className="users-container">
          <div className="users-table-container">
            <table className="users-table">
              <thead>
                <tr>
                  <th>Хэрэглэгчийн нэр</th>
                  <th>И-мэйл</th>
                  <th>Утас</th>
                  <th>Үүсгэгдсэн</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user._id}>
                    <td className="username">{user.username}</td>
                    <td>{user.email}</td>
                    <td>{user.phone || '-'}</td>
                    <td>{new Date(user.createdAt).toLocaleDateString('mn-MN')}</td>
                    <td>
                      <button
                        className="btn-view"
                        onClick={() => handleViewDetails(user)}
                      >
                        Дэлгэрэнгүй
                      </button>
                      <button
                        className="btn-delete"
                        style={{marginLeft: 8, background: '#e53e3e', color: 'white'}}
                        onClick={() => handleDeleteUser(user._id)}
                        disabled={user.role === 'admin'}
                        title={user.role === 'admin' ? 'Admin хэрэглэгчийг устгах боломжгүй' : 'Устгах'}
                      >
                        Устгах
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {selectedUser && (
            <div className="user-details-panel">
              <button
                className="btn-close-panel"
                onClick={() => setSelectedUser(null)}
              >
                ✕
              </button>

              <div className="details-content">
                <h3>Хэрэглэгчийн дэлгэрэнгүй</h3>

                <div className="detail-section">
                  <h4>Үндсэн мэдээлэл</h4>
                  <div className="detail-item"><label>Нэр:</label> <span>{selectedUser.username}</span></div>
                  <div className="detail-item"><label>И-мэйл:</label> <span>{selectedUser.email}</span></div>
                  <div className="detail-item"><label>Утас:</label> <span>{selectedUser.phone || '-'}</span></div>
                  <div className="detail-item"><label>Үүсгэгдсэн:</label> <span>{new Date(selectedUser.createdAt).toLocaleDateString('mn-MN')}</span></div>
                  <div className="detail-item"><label>Role:</label> <span>{selectedUser.role}</span></div>
                  <div className="detail-item"><label>Public ID:</label> <span>{selectedUser.publicUserId}</span></div>
                  <div className="detail-item"><label>Сүүлийн нэвтрэлт:</label> <span>{selectedUser.lastLoginAt ? new Date(selectedUser.lastLoginAt).toLocaleString('mn-MN') : '-'}</span></div>
                  <div className="detail-item"><label>IP:</label> <span>{selectedUser.lastLoginIp || '-'}</span></div>
                  <div className="detail-item"><label>User Agent:</label> <span>{selectedUser.lastUserAgent || '-'}</span></div>
                </div>

                <div className="detail-section">
                  <h4>Санхүүгийн мэдээлэл</h4>
                  <div className="detail-item"><label>Хэтэвч үлдэгдэл:</label> <span>{(selectedUser.walletBalance || 0).toLocaleString()} ₮</span></div>
                  <div className="detail-item"><label>Түр түгжигдсэн:</label> <span>{selectedUser.lockUntil ? 'Тийм' : 'Үгүй'}</span></div>
                  <div className="detail-item"><label>Failed Login Attempts:</label> <span>{selectedUser.failedLoginAttempts || 0}</span></div>
                </div>

                {Array.isArray(selectedUser.deviceSessions) && selectedUser.deviceSessions.length > 0 && (
                  <div className="detail-section">
                    <h4>Идэвхтэй төхөөрөмжүүд ({selectedUser.deviceSessions.length})</h4>
                    <div className="devices-list">
                      {selectedUser.deviceSessions
                        .filter(d => !d.revokedAt)
                        .map((device) => (
                          <div key={device.sessionId} className="device-item">
                            <div className="device-label">{device.label}</div>
                            <div className="device-info">
                              <span className="device-ip">{device.ip}</span>
                              <span className="device-date">
                                {new Date(device.lastSeenAt).toLocaleString('mn-MN')}
                              </span>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}

                <div style={{marginTop: 16, textAlign: 'right'}}>
                  <button
                    className="btn-delete"
                    style={{background: '#e53e3e', color: 'white'}}
                    onClick={() => handleDeleteUser(selectedUser._id)}
                    disabled={selectedUser.role === 'admin'}
                    title={selectedUser.role === 'admin' ? 'Admin хэрэглэгчийг устгах боломжгүй' : 'Устгах'}
                  >
                    Хэрэглэгч устгах
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminUserManager;
